import { GlCollapsibleListbox } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import { subscriptionsDropdownOptions } from '../../constants';
export default {
    name: 'SubscriptionsDropdown',
    subscriptionsDropdownOptions,
    i18n: {
        defaultDropdownText: __('Select subscription'),
        headerText: __('Change subscription'),
        resetText: __('Reset')
    },
    components: {
        GlCollapsibleListbox
    },
    data () {
        return {
            selectedValue: undefined
        };
    },
    computed: {
        dropdownText () {
            const selected = this.$options.subscriptionsDropdownOptions.find((option)=>option.value === this.selectedValue);
            return selected?.text || this.$options.i18n.defaultDropdownText;
        }
    },
    methods: {
        handleReset () {
            this.selectedValue = undefined;
        }
    }
};
